var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"dashboard","fluid":"","tag":"section"}},[_c('v-card',[_c('MerchantSettingsView',{attrs:{"merchant-id":_vm.merchantId,"merchant-name":_vm.merchantName}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }